import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useWebViewBridge } from '@fourthwall/webview-bridge'
import {
  SamplesRecommendationContent,
  useSamplesOffers,
} from '@modules/Dashboard/pages/Settings/pages/Samples'
import { routing } from '@utils/routing'

import type { Recommendation } from '../../../Recommendations.types'
import { Award } from '../../../components/Award/Award'
import { useCampaignStatus } from '../../../hooks/useCampaignStatus'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import orderSamples from '../assets/order-samples.png'

const ID = 'orderSamples'

export const useOrderSamplesRecommendation = () => {
  const { samplesOffers } = useSamplesOffers({ size: 5 })
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()
  const { methods, isWebView } = useWebViewBridge()
  const enabled = samplesOffers.enabled && recommendationsDismiss.orderSamples.visible
  const { activeIncentives } = useCampaignStatus()
  const incentive = activeIncentives.find((i) => i.recommendationId === ID)

  return {
    orderSamplesRecommendation: {
      id: ID,
      // Order samples (shows up ONLY when at least 1 product is created, but then is visible all the time)

      enabled,
      isLoading: samplesOffers.isLoading,
      suggestion: isWebView ? (
        <Suggestion
          title="Order products for yourself"
          description="Order samples of your products for quality checks and promotion."
          imageUrl={orderSamples}
          buttonLabel="Order samples"
          analytics="orderSamples"
          onButtonClick={async () => {
            await methods.openMobilePage?.({
              mobile_path: 'settings_samples',
              url: routing.settings.samples.self,
            })
          }}
        />
      ) : (
        <Suggestion
          title="Order products for yourself"
          description="Order samples of your products for quality checks and promotion."
          imageUrl={orderSamples}
          content={<SamplesRecommendationContent />}
          analytics="orderSamples"
          onDismiss={createOnDismiss(recommendationsDismiss.orderSamples.dismiss)}
          award={
            incentive ? (
              <Award value={incentive.incentive.bonus.value} currency="USD" text="sample credit" />
            ) : undefined
          }
        />
      ),
    } satisfies Recommendation,
  }
}
